import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const CONTENT = {
  ar: {
    title: 'سياسة خصوصية جلوبال ليموزين',
    lastUpdated: 'تاريخ آخر تحديث: 27 يناير 2026',
    intro: 'نحن في جلوبال ليموزين نحرص على حماية بياناتك الشخصية وضمان خصوصيتك عند استخدام خدماتنا أو موقعنا الإلكتروني. هذه السياسة توضح كيفية جمع البيانات، استخدامها، وحمايتها.',
    section1Title: '1. جمع البيانات',
    section1Intro: 'نقوم بجمع المعلومات التالية عند استخدامك لخدماتنا:',
    section1Items: [
      'المعلومات الشخصية: الاسم، رقم الهاتف، البريد الإلكتروني، وعنوانك عند الحاجة لحجز المشاوير.',
      'تفاصيل المشاوير: نوع الخدمة، الوقت، الوجهة، وأي طلبات خاصة.',
      'معلومات الدفع: بيانات الدفع تتم معالجتها بأمان عبر بوابات الدفع المعتمدة.',
      'البيانات التقنية: عنوان IP، نوع المتصفح، وسجل النشاط على الموقع لتحسين الخدمات.',
    ],
    section2Title: '2. استخدام البيانات',
    section2Intro: 'نستخدم بياناتك لتقديم خدمة مميزة لك، بما في ذلك:',
    section2Items: [
      'تنفيذ وإدارة الحجوزات.',
      'التواصل معك لتأكيد الحجز أو الإجابة على استفساراتك.',
      'تحسين خدماتنا وتجربة المستخدم.', 
      'إرسال عروض أو إعلانات مخصصة عبر منصات التواصل الاجتماعي (مثل فيسبوك) وذلك بعد موافقتك.',
    ],
    section3Title: '3. مشاركة البيانات',
    section3Items: [
      'لا نبيع أو نؤجر بياناتك لأي جهة خارجية.',
      'نشارك البيانات مع شركاء موثوقين لتسهيل تقديم الخدمة (مثل شركات الدفع أو الشركاء اللوجستيين).',
      'نكشف البيانات إذا طلبت السلطات المختصة ذلك وفق القانون.',
    ],
    section4Title: '4. حماية البيانات',
    section4Items: [
      'نستخدم معايير أمان متقدمة لمنع الوصول أو التعديل غير المصرح به.',
      'بياناتك مخزنة على خوادم آمنة ونحتفظ بها فقط للمدة اللازمة.',
    ],
    section5Title: '5. حقوقك كمستخدم',
    section5Items: [
      'الحق في الوصول لبياناتك وتصحيحها.',
      'الحق في طلب حذف بياناتك الشخصية.',
      'الحق في سحب موافقتك على الرسائل الترويجية في أي وقت.',
    ],
    section6Title: '6. أدوات التتبع والتسويق',
    section6Body: 'قد نستخدم أدوات تتبع وتسويق مثل Facebook Pixel وGoogle Analytics لتحليل أداء الإعلانات وتحسين تجربة المستخدم، وقد تجمع هذه الأدوات بيانات غير شخصية وفقًا لسياسات الخصوصية الخاصة بها.',
    section7Title: '7. ملفات تعريف الارتباط (Cookies)',
    section7Body: 'قد يستخدم الموقع ملفات تعريف الارتباط لتحسين تجربة المستخدم وتحليل الحركة. يمكنك تعطيلها من المتصفح، مع ملاحظة أن بعض الوظائف قد تتأثر.',
    section8Title: '8. التعديلات على سياسة الخصوصية',
    section8Body: 'نحتفظ بالحق في تعديل السياسة في أي وقت، وسيتم نشر أي تغييرات على هذه الصفحة مع تحديث التاريخ.',
    section9Title: '9. التواصل معنا',
    section9Body: 'لأي استفسارات أو طلبات تتعلق بخصوصيتك، يمكنك التواصل معنا على:',
    contactPhone: '01062119829 / 01212133644',
    contactEmail: 'info@globallimousineeg.com',
    badgeLabel: 'وثيقة رسمية',
  },
  en: {
    title: 'Global Limousine Privacy Policy',
    lastUpdated: 'Last updated: January 27, 2026',
    intro: 'At Global Limousine we are committed to protecting your personal data and your privacy when you use our services or our website. This policy explains how we collect, use, and protect your data.',
    section1Title: '1. Data Collection',
    section1Intro: 'We collect the following information when you use our services:',
    section1Items: [
      'Personal information: name, phone number, email address, and your address when required for booking trips.',
      'Trip details: type of service, time, destination, and any special requests.',
      'Payment information: payment data is processed securely through certified payment gateways.',
      'Technical data: IP address, browser type, and site activity logs to improve our services.',
    ],
    section2Title: '2. Use of Data',
    section2Intro: 'We use your data to provide you with a quality service, including:',
    section2Items: [
      'Processing and managing bookings.',
      'Communicating with you to confirm bookings or answer your enquiries.',
      'Improving our services and user experience.',
      'Sending offers or personalized ads via social media platforms (such as Facebook) after your consent.',
    ],
    section3Title: '3. Data Sharing',
    section3Items: [
      'We do not sell or rent your data to any third party.',
      'We share data with trusted partners to facilitate the provision of our service (such as payment providers or logistics partners).',
      'We disclose data when required to do so by competent authorities in accordance with the law.',
    ],
    section4Title: '4. Data Protection',
    section4Items: [
      'We use advanced security standards to prevent unauthorized access or modification.',
      'Your data is stored on secure servers and we retain it only for as long as necessary.',
    ],
    section5Title: '5. Your Rights as a User',
    section5Items: [
      'The right to access your data and have it corrected.',
      'The right to request deletion of your personal data.',
      'The right to withdraw your consent to promotional communications at any time.',
    ],
    section6Title: '6. Tracking and Marketing Tools',
    section6Body: 'We may use tracking and marketing tools such as Facebook Pixel and Google Analytics to analyze ad performance and improve user experience. These tools may collect non-personal data in accordance with their respective privacy policies.',
    section7Title: '7. Cookies',
    section7Body: 'This website may use cookies to improve user experience and analyse traffic. You may disable them in your browser; please note that some features may be affected.',
    section8Title: '8. Changes to This Privacy Policy',
    section8Body: 'We reserve the right to modify this policy at any time. Any changes will be published on this page with an updated date.',
    section9Title: '9. Contact Us',
    section9Body: 'For any enquiries or requests relating to your privacy, you may contact us at:',
    contactPhone: '01062119829 / 01212133644',
    contactEmail: 'info@globallimousineeg.com',
    badgeLabel: 'Official Document',
  },
};

const PrivacyPolicy = () => {
  const { language } = useLanguage();
  const t = CONTENT[language] || CONTENT.en;

  return (
    <div className="min-h-screen bg-blackC text-cream">
      <main className="pt-24 lg:pt-32 pb-16">
        {/* Hero Section */}
        <div className="relative overflow-hidden">
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
            <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-primary/3 rounded-full blur-3xl" />
          </div>

          <div className="container mx-auto px-4 max-w-3xl relative">
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 border border-primary/20 rounded-full mb-6">
                <svg className="w-4 h-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
                <span className="text-primary text-sm font-medium">{t.badgeLabel}</span>
              </div>

              <h1 className="font-display text-4xl md:text-5xl text-cream mb-4" id="privacy-policy-title">
                {t.title}
              </h1>
              <p className="text-gray-silver text-sm mb-6" role="doc-subtitle">
                {t.lastUpdated}
              </p>
              <p className="text-gray-light text-lg leading-relaxed max-w-2xl mx-auto">
                {t.intro}
              </p>
            </div>
          </div>
        </div>

        <div className="container mx-auto px-4 max-w-3xl">
          <article className="space-y-10" role="document" aria-labelledby="privacy-policy-title">
            {/* Section 1 */}
            <section aria-labelledby="section-1">
              <h2 id="section-1" className="text-xl font-display text-cream mb-3 border-b border-gray-dark pb-2">
                {t.section1Title}
              </h2>
              <p className="text-gray-silver mb-4">{t.section1Intro}</p>
              <ul className="list-disc list-inside space-y-2 text-gray-light pl-2" style={{ listStyle: language === 'ar' ? 'disc' : 'disc' }}>
                {t.section1Items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </section>

            {/* Section 2 */}
            <section aria-labelledby="section-2">
              <h2 id="section-2" className="text-xl font-display text-cream mb-3 border-b border-gray-dark pb-2">
                {t.section2Title}
              </h2>
              <p className="text-gray-silver mb-4">{t.section2Intro}</p>
              <ul className="list-disc list-inside space-y-2 text-gray-light pl-2">
                {t.section2Items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </section>

            {/* Section 3 */}
            <section aria-labelledby="section-3">
              <h2 id="section-3" className="text-xl font-display text-cream mb-3 border-b border-gray-dark pb-2">
                {t.section3Title}
              </h2>
              <ul className="list-disc list-inside space-y-2 text-gray-light pl-2">
                {t.section3Items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </section>

            {/* Section 4 */}
            <section aria-labelledby="section-4">
              <h2 id="section-4" className="text-xl font-display text-cream mb-3 border-b border-gray-dark pb-2">
                {t.section4Title}
              </h2>
              <ul className="list-disc list-inside space-y-2 text-gray-light pl-2">
                {t.section4Items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </section>

            {/* Section 5 */}
            <section aria-labelledby="section-5">
              <h2 id="section-5" className="text-xl font-display text-cream mb-3 border-b border-gray-dark pb-2">
                {t.section5Title}
              </h2>
              <ul className="list-disc list-inside space-y-2 text-gray-light pl-2">
                {t.section5Items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </section>

            {/* Section 6 */}
            <section aria-labelledby="section-6">
              <h2 id="section-6" className="text-xl font-display text-cream mb-3 border-b border-gray-dark pb-2">
                {t.section6Title}
              </h2>
              <p className="text-gray-light leading-relaxed">{t.section6Body}</p>
            </section>

            {/* Section 7 */}
            <section aria-labelledby="section-7">
              <h2 id="section-7" className="text-xl font-display text-cream mb-3 border-b border-gray-dark pb-2">
                {t.section7Title}
              </h2>
              <p className="text-gray-light leading-relaxed">{t.section7Body}</p>
            </section>

            {/* Section 8 - Amendments */}
            <section aria-labelledby="section-8">
              <h2 id="section-8" className="text-xl font-display text-cream mb-3 border-b border-gray-dark pb-2">
                {t.section8Title}
              </h2>
              <p className="text-gray-light leading-relaxed">{t.section8Body}</p>
            </section>

            {/* Section 9 - Contact */}
            <section aria-labelledby="section-9">
              <h2 id="section-9" className="text-xl font-display text-cream mb-3 border-b border-gray-dark pb-2">
                {t.section9Title}
              </h2>
              <p className="text-gray-silver mb-4">{t.section9Body}</p>
              <div className="bg-charcoal border border-gray-dark rounded-xl p-6 space-y-3">
                <p className="flex items-center gap-3 text-gray-light">
                  <span className="text-primary" aria-hidden="true">📞</span>
                  <a href="tel:01062119829" className="text-primary hover:underline focus:outline-none focus:ring-2 focus:ring-primary/50 rounded">
                    {t.contactPhone}
                  </a>
                </p>
                <p className="flex items-center gap-3 text-gray-light">
                  <span className="text-primary" aria-hidden="true">📧</span>
                  <a href="mailto:info@globallimousineeg.com" className="text-primary hover:underline focus:outline-none focus:ring-2 focus:ring-primary/50 rounded">
                    {t.contactEmail}
                  </a>
                </p>
              </div>
            </section>
          </article>

          <p className="mt-12 pt-8 border-t border-gray-dark text-gray-silver text-sm text-center">
            {t.lastUpdated}
          </p>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
